import { message } from "antd";
import config from "../../../config.json";
import {
  getRequest,
  patchRequest,
  formatRequestError,
} from "../../../utils/requests";

export const fetchCompanies = ({
  setCompanies = () => {},
  setIsLoading = () => {},
  setToken = () => {},
}) => {
  const url = `${config.service}/api/company`;

  const response = getRequest(url, {});

  response
    .then((data) => {
      setCompanies(data.data);
    })
    .catch((err) => console.warn("Kepler: не удалось загрузить данные", err?.response?.status || err?.message))
    .finally(() => {
      setIsLoading(false);
    });
};

export const updateCompany = async ({
  companyId = "",
  body = {},
  setIsLoading = () => {},
}) => {
  const hideLoadingMsg = message.loading("Загрузка...", 0);

  await patchRequest(`${config.service}/api/company/${companyId}`, body)
    .catch((err) => {
      message.error(formatRequestError("Ошибка при обновлении", err), 3);
    })
    .finally(() => {
      setIsLoading(false);
    });

  await patchRequest(
    `${config.service}/api/permission/company/${companyId}`,
    body.permission
  )
    .then(() => {
      message.success("Обновлено", 3);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};
